export default __webpack_public_path__ + "static/media/selfdriving.ccfba717.png";